import { Grid, FormControl, Typography, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { DATE_FORMATS } from '@callmart/types';
import ReactHookFormSelect from '../ReactHookForm/ReactHookFormSelect';
import { fieldIsRequiredMsg } from '../../utils/componentUtils';
import { RepetitionIntervalType, getWeekDays, getOrdinalNumberLabel } from './utils/serieDialogUtils';

const RepetitionIntervalSelector = ({
    currentMonthDates,
    ordinalNumbersForDayInMonth,
    control,
    defaultValue,
    rules,
    formErrors,
    ...props
}) => {
    const { t } = useTranslation('allDeltas');

    return (
        <FormControl {...props} fullWidth={true}>
            <Controller
                name="repetitionIntervalType"
                control={control}
                defaultValue={defaultValue}
                rules={rules}
                render={({ field }) => (
                    <RadioGroup {...field}>
                        <Grid container spacing={1}>
                            <Grid item sm={2}>
                                <FormControlLabel
                                    value={RepetitionIntervalType.DAY_NUMBER_REPETITION}
                                    control={<Radio color="primary" />}
                                    label=""
                                />
                            </Grid>
                            <Grid item sm={8}>
                                <ReactHookFormSelect
                                    name="repetitionIntervalDayNumber"
                                    control={control}
                                    label=""
                                    mainProp="text"
                                    valueProp="value"
                                    options={currentMonthDates?.map((date) => ({
                                        value: parseInt(date.format(DATE_FORMATS.DAY_ONLY)),
                                        text: parseInt(date.format(DATE_FORMATS.DAY_ONLY)),
                                    }))}
                                    rules={{ required: { value: true, message: fieldIsRequiredMsg } }}
                                    formErrors={formErrors}
                                />
                            </Grid>
                            <Grid item sm={2}>
                                <Typography variant="body1">{t('serie.day')}</Typography>
                            </Grid>
                            <Grid item sm={2} alignItems="flex-start">
                                <FormControlLabel
                                    value={RepetitionIntervalType.DAY_ORDINAL_NUMBER_REPETITION}
                                    control={<Radio color="primary" />}
                                    label=""
                                />
                            </Grid>
                            <Grid item sm={5}>
                                <ReactHookFormSelect
                                    name="repetitionIntervalDayOrdinalNumber"
                                    control={control}
                                    label=""
                                    mainProp="text"
                                    valueProp="value"
                                    options={ordinalNumbersForDayInMonth?.map((ordinalNumber) => ({
                                        value: ordinalNumber,
                                        text: getOrdinalNumberLabel(ordinalNumber, t),
                                    }))}
                                    rules={{ required: { value: true, message: fieldIsRequiredMsg } }}
                                    formErrors={formErrors}
                                />
                            </Grid>
                            <Grid item sm={5}>
                                <ReactHookFormSelect
                                    name="repetitionIntervalDayOfWeek"
                                    control={control}
                                    label=""
                                    mainProp="text"
                                    valueProp="value"
                                    options={getWeekDays(t)}
                                    rules={{ required: { value: true, message: t('validation.dayOfWeekRequired') } }}
                                />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                )}
            />
        </FormControl>
    );
};

export default RepetitionIntervalSelector;
